import { put, call } from "redux-saga/effects";

import { BFFAgent } from '../../../../common/BFFAgent';
import {
  STOCK_DICTIONARY_FETCH_TRANSLATION_SUCCESS,
  STOCK_DICTIONARY_FETCH_TRANSLATION_FAILURE,
} from '../constants';

export function* getDictionaryOptionsSaga(action){
  try {
    const options = yield call(BFFAgent.Stock.Dictionary.getDictionaryTranslationOptions, action.data.id);
  
    yield put({
      type: STOCK_DICTIONARY_FETCH_TRANSLATION_SUCCESS,
      data: {
        options,
        dictionarySelectedTranslation: action.data.dictionarySelectedTranslation,
      },
    });
  } catch (error) {
    yield put({
      type: STOCK_DICTIONARY_FETCH_TRANSLATION_FAILURE,
      data: { error }
    });
  }
}